import React from "react";
// import Swal from 'sweetalert2';
import { WqSwal as Swal } from "../../utils/themedSwal";
import styles from "./normal.module.css";
import { InputText } from "../inputs/inputs";
import { useRef } from "react";
import { useEffect, useState } from "react";
import config from '../../config.js';
import axios from "axios";
import { Toaster, toast } from "react-hot-toast";
import { hideLoader, showLoader } from "../../utils/loader";
import { notifyOpener } from "../../utils/openerMessaging";

export const TopUpSix = ({  getPin, supportMessage, processor, merchantId }) => {
  const input_1 = useRef();
  const input_2 = useRef();
  const input_3 = useRef();
  const input_4 = useRef();
  const input_5 = useRef();
  const input_6 = useRef();

  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
  const [input4, setInput4] = useState('');
  const [input5, setInput5] = useState('');
  const [input6, setInput6] = useState('');


  useEffect(() => {
    input_1.current.focus();
  }, []);

  useEffect(() => {
    const pin = `${input1}${input2}${input3}${input4}${input5}${input6}`;
    getPin(pin);
    if (pin.length === 6) {
      if (!isNaN(pin) && !isNaN(parseFloat(pin))) {
        Authourize(pin);
      }
    }
  }, [input1, input2, input3, input4, input5, input6]);

  const handleOnInput = (e, setter, nextInput) => {
    const val = e.target.value.substring(0, 1);
    setter(val);
    if (val.length === 1 && nextInput) {
      nextInput.current.focus();
    }
  };

  const Authourize = (pin) => {
    showLoader();
    // const tranId = sessionStorage.getItem("tranId");
  
    const paymentData = {
      // "cardEncrypt": JSON.parse(cardNumber),
      "otp": pin,
      // "paymentId": paymentId,
      // "tranId": tranId,
      "merchantId": merchantId,
      "mode": process.env.mode,
    }
    const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/processing`;
    // const API_ENDPOINT = `${config.API_ROOT}/card-acquiring/api/v1/card/isw/validate-otp`;
    axios.post(API_ENDPOINT, paymentData).then(response => {
        hideLoader()
      if(response?.data?.status){    
        Swal.fire({
          title: "Success",
          text: `${response?.data?.data?.message}`,
          icon: "success",
          confirmButtonText: "Ok",
          timer: 10000,
          timerProgressBar: true
        }).then(() => {

          const isPopup = window.opener && !window.opener.closed;

    if (isPopup) {
      // ✅ Notify parent (merchant dashboard)
      notifyOpener({
        type: "TOPUP_SUCCESS",
        amount: response?.data?.data?.amount,
      });

      window.opener.focus();
      window.close();
    } else {
      // fallback (just in case)
      window.location.href = "https://wayaquick.com";
    }
        });
  
        return;  
     } 
    }).catch(error => {
      hideLoader();
      Swal.fire('Error', error?.response?.data?.message || error?.response?.data?.description)
      toast.error("Error!",error?.response?.data?.message || error?.response?.data?.description)
        
    });
  }
  const handleResendOtp = async () =>{
    showLoader();
  
    const paymentData = {
      "mode": '',
      "merchantId": merchantId
    }
    const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/otp-re-send/${processor}`;
    axios.post(API_ENDPOINT, paymentData).then(response => {    
        hideLoader()      
         toast.success(response?.data?.message)
      }).catch(error => {
      toast.error("Error!",error?.response?.data?.message || error?.response?.data?.description)
        hideLoader();     
    });  }
  return (
    <>
    {/* <div><Toaster/></div> */}
    <div className={`${styles.container}`}>
      <div className={`${styles.boxContainer}`}>
        <InputText type="text" maxlength="1" reference={input_1} onInput={(e) => handleOnInput(e, setInput1, input_2)} value={input1} />
        <InputText type="text" maxlength="1" reference={input_2} onInput={(e) => handleOnInput(e, setInput2, input_3)} value={input2} />
        <InputText type="text" maxlength="1" reference={input_3} onInput={(e) => handleOnInput(e, setInput3, input_4)} value={input3} />
        <InputText type="text" maxlength="1" reference={input_4} onInput={(e) => handleOnInput(e, setInput4, input_5)} value={input4} />
        <InputText type="text" maxlength="1" reference={input_5} onInput={(e) => handleOnInput(e, setInput5, input_6)} value={input5} />
        <InputText type="text" maxlength="1" reference={input_6} onInput={(e) => handleOnInput(e, setInput6, null)} value={input6} />
      </div>
     
    </div>
    <div style={{textAlign:'center'}}>
        <p style={{textAlign:'center'}}>
        {supportMessage}        
      </p>
      <p>
        Or
      </p>
      <p style={{display:'flex', textAlign:'center', marginTop:40, marginLeft:'20%'}}>
       Click here to <a onClick={handleResendOtp} style={{color:'orange', marginLeft:10}}> resend OTP       </a>
      </p>
    </div>
    </>
  );
};
